<section class="hero" [ngClass]=" {'is-dark': ctrl.busquedaActivada, 'is-primary': !ctrl.busquedaActivada } ">
    <div class="hero-body" style="position:relative;">

        <div class="control is-grouped" style="position:absolute; top:0.5em; right:0em;">
            
            <p class="control" *ngIf="!ctrl.busquedaActivada">
                <a class="button is-primary tooltip">
                    <span class="icon fa-2x">
                        <i class="icon-worldwide"></i>
                    </span>
                    <span class="tooltiptext">Actualizar</span>
                </a>
            </p>

            <p class="control">
                <a class="button tooltip" [ngClass]="ctrl.busquedaActivada ? 'is-dark' : 'is-primary'"   (click)="ctrl.imprimir()">
                    <span class="icon fa-2x">
                        <i class="icon-printer2"></i>
                    </span>
                    <span class="tooltiptext">Imprimir</span>
                </a>
            </p>
        </div>

        <div class="container is-fluid">

            <h1 class="title" *ngIf="!ctrl.busquedaActivada">
                <span class="icon is-medium"><i class="{{icono}}"></i></span>&nbsp; {{modulo_actual}}
            </h1>
        </div>

        <!--<div class="control">
            <form name="form" novalidate (ngSubmit)="ctrl.enviar()">
                <div class="columns">
                    <div class="column is-4" style="text-align:center">
                        <div class="select">
                            <select class="select" name="orden" style="width:100%;"  [(ngModel)]="orden">
                                <option selected value="categorias_id">Ordenar por categorías</option>
                                <option value="clave">Ordenar por clave</option>
                            </select>
                        </div>
                    </div>
                    <div class="column is-4" style="text-align:center">
                        <div class="select">
                            <select class="select" name="filtro" style="width:100%;" [(ngModel)]="filtro">                                
                                <option selected value="menor-minimo">Menores al mínimo</option>
                                <option value="agotado">Agotados</option>
                            </select>
                        </div>
                    </div>
                    <div class="column is-4" style="text-align:center">
                        <button class="button is-success is-medium tooltip" type="button" (click)="ctrl.listar()">Buscar</button>
                    </div>
                </div>
            </form>
        </div>-->

    </div>
</section>

<div class="is-fullwidth has-text-centered" *ngIf="ctrl.cargando">
    <br>
    <span class="tag is-primary is-large "><span class="icon"><i class="icon-worldwide fa-spin"></i></span> &nbsp;<span>Cargando...</span></span>
    <br>
    <br>
</div>